/*
 * Image Gallery Video Theme Styles
 */
export default {
    baseStyle: {
        container: {
            position: 'relative',
            width: '100%',
            height: '100%'
        },

        poster: {
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'blur(8px)',
            transform: 'scale(1.05)',
            zIndex: 1
        },

        spinnerWrapper: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2
        },

        spinner: {
            display: 'block',
            width: '40px',
            height: '40px',
            borderRadius: 'full',
            border: '3px solid rgba(255,255,255,0.3)',
            borderTopColor: 'white',
            animation: 'spin 0.8s linear infinite'
        },

        videoWrapper: {
            position: 'absolute',
            inset: 0,
            zIndex: 3,
            transition: 'opacity 0.4s ease'
        }
    },

    parts: [
        'container',
        'poster',
        'spinnerWrapper',
        'spinner',
        'videoWrapper'
    ]
}